const clickOutside = {
    bind: function (el, binding, vnode) {
        window.event = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        // console.log('bind');
        document.body.addEventListener('click', window.event);
    },
    unbind: function (el) {
        // console.log('un-bind');
        document.body.removeEventListener('click', window.event);
    },
};

export default clickOutside;